<lib-password-form titleKey="{{ ['password', 'reset_password'] | translate }}" type="reset"></lib-password-form>
